import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import { FaqServiceSupportProps } from './faq-service-support';
import help from './faq-service-support.help';
import translations from './i18n';

function useFaqServiceSupportHook(props: FaqServiceSupportProps) {
  useResourceBundle(translations, undefined, '72926742-daff-4ca4-90f6-74597f73eb88');
  useHelpBundle(help);

  const { t } = useTranslation();

  const superUserRole= sessionStorage.getItem('superUserRole');

  return {
    t, superUserRole
  };
}

export default useFaqServiceSupportHook;
